<template>
	<div class="scrollable only-y">
	<div :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text">
                Data
            </h2>
		</div>
	</div>
	<el-card>
		<el-tabs type="border-card" v-model="activeTab" v-loading="loadingPage">
			<el-tab-pane label="WABA Identity" name="wabaIdentity">
                <el-row>
                    <el-col :xl="5" :lg="5" :md="12" :sm="12" :xs="12">
                        <el-card style="background-color:#5EA369; font-size:18px; color:#ffffff; font-weight:bold; height:100px; word-wrap: break-word; text-align: center;display: flex;align-items: center;justify-content:center;" class="mb-10">
                            <span style="font-size:16px;">Total WABA : </span>
                            <span style="font-size:28px;">
                                {{ wabaTotalData ? wabaTotalData : 0 }}
                            </span>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                        <el-select @change="selectWabaSearch" v-model="wabaSelectBy" placeholder="Select by" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                            <el-option
                                v-for="(items, idx) in optionWabaSelectBy"
                                :key="idx"
                                :label="items.name"
                                :value="items.value"
                            >
                            </el-option>
                        </el-select>

                        <el-input
                            style="width:200px;"
                            class="mb-10"
                            size="mini"
                            prefix-icon="el-icon-search"
                            :placeholder="wabaPlaceholder"
                            clearable
                            v-model="searchWaba"
                            :disabled="wabaSelectBy === '' ? true : false"
                        />
                                
                        <el-button-group class="mr-10 ml-10">
                            <el-button type="primary" round size="mini" @click="btnSearchWaba" class="animated fadeInRight" style="background-color: #0047FF;">
                                <i class="el-icon-search"/>
                            </el-button>
                        </el-button-group>
                        <el-button-group class="mr-10 ml-10">
                            <el-button @click="dialogAddWabaIdentity=true, clear('waba')" type="primary" size="mini" class="animated fadeInRight">
                                + Add WABA
                            </el-button>
                        </el-button-group>
                    </el-col>
                </el-row>
				<el-row :gutter="10" style="z-index: 0">
					<el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<el-card shadow="card-shadow--small">
							<div class="group-list scrollable only-y">
                                <el-pagination
									background
									prev-text="Prev"
									next-text="Next"
									layout="prev, pager, next"
									:page-size="20"
                                    @current-change="paginationWabaChange"
                                    :current-page="paginationWaba.page"
                                    :total="parseInt(wabaTotalData)">
								</el-pagination>
								<template>
									<el-table style="width: 100%; color: #000 !important" v-loading="loadingTableWabaIdentity" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(246, 246, 245, 0.8)" :data="wabaListData">
										<el-table-column width="300" label="WABA ID">
											<template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.identityNumber ? props.row.identityNumber : '-' }}</p>
											</template>
										</el-table-column>
										<el-table-column width="400" label="WABA Name">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.maskingName ? props.row.maskingName : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="200" label="PIC Name">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.pic && props.row.pic.username ? props.row.pic.username : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column label="Action" align="center" width="200">
                                            <template slot-scope="props">
                                                <el-button type="primary" size="mini" @click="getDetailFbbm(props.row.id, 'waba')">
                                                    <i class="mdi mdi-eye"></i>
                                                </el-button>
                                                <el-button type="danger" size="mini" :loading="loadingBtnDeleteWaba" @click="deleteFbbm(props.row.id, 'waba', props.row.maskingName)">
                                                    <i class="mdi mdi-delete-forever"></i> 
                                                </el-button>
                                            </template>
										</el-table-column>
									</el-table>
								</template>
                                <el-pagination
									background
									prev-text="Prev"
									next-text="Next"
									layout="prev, pager, next"
									:page-size="20"
									class="mt-10"
                                    @current-change="paginationWabaChange"
                                    :current-page="paginationWaba.page"
                                    :total="parseInt(wabaTotalData)">
								</el-pagination>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="FBBM Identity" name="fbbmIdentity">
				<el-row>
                    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                        <el-input
                            style="width:200px;"
                            class="mb-10"
                            size="mini"
                            prefix-icon="el-icon-search"
                            placeholder="FBBM Name"
                            clearable
                            v-model="searchFbbm"
                        />
                                
                        <el-button-group class="mr-10 ml-10">
                            <el-button type="primary" round size="mini" @click="getFbIdentity('fbbm', 'masking_name')" class="animated fadeInRight" style="background-color: #0047FF;">
                                <i class="el-icon-search"/>
                            </el-button>
                        </el-button-group>
                        <el-button-group class="mr-10 ml-10">
                            <el-button @click="dialogAddFbbm=true, clear('fbbm')" type="primary" size="mini" class="animated fadeInRight">
                                + Add FBBM
                            </el-button>
                        </el-button-group>
                    </el-col>
                </el-row>
				<el-row :gutter="10" style="z-index: 0">
					<el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<el-card shadow="card-shadow--small">
							<div class="group-list scrollable only-y">
                                <el-pagination
									background
									prev-text="Prev"
									next-text="Next"
									layout="prev, pager, next"
									:page-size="20"
                                    @current-change="paginationFbbmChange"
                                    :current-page="paginationFbbm.page"
                                    :total="parseInt(fbbmTotalData)">
								</el-pagination>
								<template>
									<el-table style="width: 100%; color: #000 !important" v-loading="loadingFbbm" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(246, 246, 245, 0.8)" :data="fbbmListData">
										<el-table-column width="400" label="FBBM ID">
											<template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.identityNumber ? props.row.identityNumber : '-' }}</p>
											</template>
										</el-table-column>
										<el-table-column width="400" label="FBBM Name">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.maskingName ? props.row.maskingName : '-' }}</p>
											</template>
                                        </el-table-column>
                                        <el-table-column label="Action" align="center" width="300">
                                            <template slot-scope="props">
                                                <el-button type="primary" size="mini" @click="getDetailFbbm(props.row.id, 'fbbm')">
                                                    <i class="mdi mdi-eye"></i>
                                                </el-button>
                                                <el-button type="danger" size="mini" :loading="loadingBtnDeleteFbbm" @click="deleteFbbm(props.row.id, 'fbbm', props.row.maskingName)">
                                                    <i class="mdi mdi-delete-forever"></i> 
                                                </el-button>
                                            </template>
                                        </el-table-column>
									</el-table>
								</template>
                                <el-pagination
									background
									prev-text="Prev"
									next-text="Next"
									layout="prev, pager, next"
									:page-size="20"
									class="mt-10"
                                    @current-change="paginationFbbmChange"
                                    :current-page="paginationFbbm.page"
                                    :total="parseInt(fbbmTotalData)">
								</el-pagination>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="Client" name="client">
                <el-row>
                    <el-col :xl="5" :lg="5" :md="12" :sm="12" :xs="12">
                        <el-card style="background-color:#5EA369; font-size:18px; color:#ffffff; font-weight:bold; height:100px; word-wrap: break-word; text-align: center;display: flex;align-items: center;justify-content:center;" class="mb-10">
                            <span style="font-size:16px;">Total Client : </span>
                            <span style="font-size:28px;">
                                {{ clientTotalData ? clientTotalData : 0 }}
                            </span>
                        </el-card>
                    </el-col>
                </el-row>
				<el-row>
                    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                        <el-input
                            style="width:200px;"
                            class="mb-10"
                            size="mini"
                            prefix-icon="el-icon-search"
                            placeholder="Client Name"
                            clearable
                            v-model="filterSearchClientName"
                        />
                                
                        <el-button-group class="mr-10 ml-10">
                            <el-button type="primary" round size="mini" :loading="loadingReportTable" class="animated fadeInRight" style="background-color: #0047FF;" @click="getClient(1)">
                                <i class="el-icon-search"/>
                            </el-button>
                        </el-button-group>
                        <el-button-group class="mr-10 ml-10">
                            <el-button @click="dialogAddClient=true, clear('client')" type="primary" size="mini" class="animated fadeInRight">
                                + Add Client
                            </el-button>
                        </el-button-group>
                    </el-col>
                </el-row>
				<el-row :gutter="10" style="z-index: 0">
					<el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<el-card shadow="card-shadow--small">
							<div class="group-list scrollable only-y">
                                <el-pagination
									background
									prev-text="Prev"
									next-text="Next"
									layout="prev, pager, next"
									:page-size="20"
                                    @current-change="paginationClientChange"
                                    :current-page="paginationClient.page"
                                    :total="parseInt(clientTotalData)">
								</el-pagination>
								<template>
									<el-table style="width: 100%; color: #000 !important" v-loading="loadingTable" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(246, 246, 245, 0.8)" :data="clientData">
										<el-table-column width="200" label="Client Name">
											<template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.name ? props.row.name : '-' }}</p>
											</template>
										</el-table-column>
										<el-table-column width="150" label="Initial">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.initial ? props.row.initial : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="200" label="NPWP Number">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.npwp_number ? props.row.npwp_number : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="200" label="NPWP Address">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.npwp_address ? props.row.npwp_address : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="300" label="Document">
                                            <template slot-scope="props">
                                                <a
                                                    v-if="props.row.media.length > 0"
                                                    style="font-size: 14px;"
                                                    target="_blank"
                                                    :href="props.row.media[0].full_url"
                                                    class="mr-10 wabalink-short-url"
                                                >
                                                    {{props.row.media[0].file_name}}
                                                </a>
                                                <span v-else-if="props.row.media.length === 0">
                                                    -
                                                </span>
											</template>
                                        </el-table-column>
										<el-table-column width="150" label="Status">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.status ? props.row.status : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="200" label="Churn Date">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.churn_date && props.row.status === 'churn' ? props.row.churn_date : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column label="Action" align="center" width="300">
                                            <template slot-scope="props">
                                                <el-button type="primary" size="mini" @click="getDetailClient(props.row.id)">
                                                        <i class="mdi mdi-eye"></i>
                                                </el-button>
                                                <el-button @click="deleteClient(props.row.id, 'client', props.row.name)" type="danger" size="mini">
                                                        <i class="mdi mdi-delete-forever"></i> 
                                                </el-button>
                                            </template>
										</el-table-column>
									</el-table>
								</template>
                                <el-pagination
									background
									prev-text="Prev"
									next-text="Next"
									layout="prev, pager, next"
									:page-size="20"
									class="mt-10"
                                    @current-change="paginationClientChange"
                                    :current-page="paginationClient.page"
                                    :total="parseInt(clientTotalData)">
								</el-pagination>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="Assign" name="assign">
                <el-row>
                    <el-col :xl="5" :lg="5" :md="12" :sm="12" :xs="12">
                        <el-card style="background-color:#5EA369; font-size:18px; color:#ffffff; font-weight:bold; height:100px; word-wrap: break-word; text-align: center;display: flex;align-items: center;justify-content:center;" class="mb-10">
                            <span style="font-size:16px;">Total Assign : </span>
                            <span style="font-size:28px;">
                                {{ assignTotalData ? assignTotalData : 0 }}
                            </span>
                        </el-card>
                    </el-col>
                </el-row>
				<el-row>
                    <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                        <el-select @change="selectClientFilter" v-model="filterSearchAssign.client_id" placeholder="Client Name" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" clearable>
                            <el-option
                                v-for="items in listClient"
                                :key="items.id"
                                :label="items.name"
                                :value="items.id"
                            >
                            </el-option>
                        </el-select>

                        <el-select v-model="filterSearchAssign.customer_id" placeholder="Company Name" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5" clearable :disabled="!filterSearchAssign.client_id">
                            <el-option
                                v-for="items in listCustomerClient"
                                :key="items.customer_id"
                                :label="items.customer_name"
                                :value="items.customer_id"
                            >
                            </el-option>
                        </el-select>

                        <el-input
                            style="width:200px;"
                            class="mb-10"
                            size="mini"
                            prefix-icon="el-icon-search"
                            placeholder="Search by Waba Id"
                            clearable
                            v-model="searchAssignWabaId"
                        />

                        <el-button-group class="mr-10 ml-10">
                            <el-button type="primary" round size="mini" :loading="loadingReportTable" class="animated fadeInRight" style="background-color: #0047FF;" @click="filterAssign()">
                                <i class="el-icon-search"/>
                            </el-button>
                        </el-button-group>
                        <el-button-group class="mr-10 ml-10">
                            <el-button @click="dialogAddAssignNumber=true, clear('assign')" type="primary" size="mini" class="animated fadeInRight">
                                + Assign Number
                            </el-button>
                        </el-button-group>
                    </el-col>
                </el-row>
				<el-row :gutter="10" style="z-index: 0">
					<el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
						<el-card shadow="card-shadow--small">
							<div class="group-list scrollable only-y">
                                <el-pagination
									background
									prev-text="Prev"
									next-text="Next"
									layout="prev, pager, next"
									:page-size="20"
                                    @current-change="paginationAssignChange"
                                    :current-page="paginationAssign.page"
                                    :total="parseInt(assignTotalData)">
								</el-pagination>
								<template>
									<el-table style="width: 100%; color: #000 !important" v-loading="loadingTable" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(246, 246, 245, 0.8)" :data="assignData">
										<el-table-column width="170" label="Client Name">
											<template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.customer && props.row.customer.master_client && props.row.customer.master_client.name ? props.row.customer.master_client.name : '-' }}</p>
											</template>
										</el-table-column>
										<el-table-column width="300" label="Company Name">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.customer && props.row.customer.customer_name ? props.row.customer.customer_name : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="150" label="Phone Number">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.phone_number ? props.row.phone_number : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="150" label="WABA ID">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.waba_id ? props.row.waba_id : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="150" label="FBBM ID">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.fbbm_id ? props.row.fbbm_id : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="200" label="PIC Name">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.pic ? props.row.pic.username : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="150" label="Status">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.status ? props.row.status : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column width="150" label="Churn Date">
                                            <template slot-scope="props">
										        <p style="font-weight:bold;">{{ props.row.churn_date && props.row.status === 'churn' ? props.row.churn_date : '-' }}</p>
											</template>
                                        </el-table-column>
										<el-table-column label="Action" align="center" width="300">
                                            <template slot-scope="props">
                                                <el-button type="primary" size="mini" @click="getDetailAssign(props.row.id)">
                                                    <i class="mdi mdi-eye"></i>
                                                </el-button>
                                                <el-button @click="deleteAssign(props.row.id, 'assign', props.row)" type="danger" size="mini">
                                                    <i class="mdi mdi-delete-forever"></i> 
                                                </el-button>
                                            </template>
										</el-table-column>
									</el-table>
								</template>
                                <el-pagination
									background
									prev-text="Prev"
									next-text="Next"
									layout="prev, pager, next"
									:page-size="20"
									class="mt-10"
                                    @current-change="paginationAssignChange"
                                    :current-page="paginationAssign.page"
                                    :total="parseInt(assignTotalData)">
								</el-pagination>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</el-card>

    <!-- modal dialog add waba identity -->
    <el-dialog title="Add WABA Identity" :visible.sync="dialogAddWabaIdentity" v-loading="loadingAddWabaIdentity" id="html-2-pdfwrapper">
        <el-row>
            <el-card class="mb-5">
                <el-form label-width="120px">
                    <el-form-item label="WABA ID">
                        <el-input @keypress.native="numberOnly" v-model="addWaba.wabaId" placeholder="Waba ID"/>
                    </el-form-item>
                    <el-form-item label="WABA Name">
                        <el-input v-model="addWaba.wabaName" placeholder="Waba Name"/>
                    </el-form-item>
                    <el-form-item label="PIC Name">
                        <el-select v-model="addWaba.pic" placeholder="PIC Name" style="width:100%;" :default-first-option="true" class="mb-10 mr-5">
                            <el-option
                                v-for="item in listPic"
                                :key="item.user_id"
                                :label="item.label"
                                :value="item.user_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div style="text-align:right;">
                    <el-button :loading="btnLoadingAddWaba" type="primary" size="medium" class="animated fadeInRight" @click="createFbbmWaba('waba')">
                        Add
                    </el-button>
                    <el-button type="danger" size="medium" class="animated fadeInRight" @click="dialogAddWabaIdentity=false">
                        Cancel
                    </el-button>
                </div>
            </el-card>
        </el-row>
    </el-dialog>

    <!-- modal dialog edit waba identity -->
    <el-dialog title="Edit WABA Identity" :visible.sync="dialogEditWabaIdentity" v-loading="loadingEditWabaIdentity" id="html-2-pdfwrapper">
        <el-row>
            <el-card class="mb-5">
                <el-form label-width="120px">
                    <el-form-item label="WABA ID">
                        <el-input @keypress.native="numberOnly" v-model="wabaDataDetail.identityNumber" placeholder="Waba Id"/>
                    </el-form-item>
                    <el-form-item label="WABA Name">
                        <el-input v-model="wabaDataDetail.maskingName" placeholder="Waba Name"/>
                    </el-form-item>
                    <el-form-item label="PIC Name">
                        <el-select v-model="wabaDataDetail.pic_business" placeholder="PIC Name" style="width:200px;" :default-first-option="true" class="mb-10 mr-5">
                            <el-option
                                v-for="item in listPic"
                                :key="item.user_id"
                                :label="item.label"
                                :value="item.user_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div style="text-align:right;">
                    <el-button :loading="btnLoadingEditWaba" type="primary" size="medium" class="animated fadeInRight" @click="editFbbm('waba')">
                        Save
                    </el-button>
                    <el-button type="danger" size="medium" class="animated fadeInRight" @click="dialogEditWabaIdentity=false">
                        Cancel
                    </el-button>
                </div>
            </el-card>
        </el-row>
    </el-dialog>

    <!-- modal dialog add fbbm -->
    <el-dialog title="Add FBBM" :visible.sync="dialogAddFbbm" v-loading="loadingAddFbbm" id="html-2-pdfwrapper">
        <el-row>
            <el-card class="mb-5">
                <el-form label-width="120px">
                    <el-form-item label="FBBM ID">
                        <el-input @keypress.native="numberOnly" v-model="addFbbm.fbbmId" placeholder="FBBM ID" />
                    </el-form-item>
                    <el-form-item label="FBBM Name">
                        <el-input v-model="addFbbm.fbbmName" placeholder="FBBM Name" />
                    </el-form-item>
                </el-form>
                <div style="text-align:right;">
                    <el-button type="primary" size="medium" class="animated fadeInRight" @click="createFbbmWaba('fbbm')">
                        Add
                    </el-button>
                    <el-button type="danger" size="medium" class="animated fadeInRight" @click="dialogAddFbbm=false">
                        Cancel
                    </el-button>
                </div>
            </el-card>
        </el-row>
    </el-dialog>

    <!-- modal dialog edit fbbm -->
    <el-dialog title="Edit FBBM" :visible.sync="dialogEditFbbm" v-loading="loadingFbbmDetail" id="html-2-pdfwrapper">
        <el-row>
            <el-card class="mb-5">
                <el-form label-width="120px">
                    <el-form-item label="FBBM ID">
                        <el-input @keypress.native="numberOnly" v-model="fbbmDataDetail.identityNumber" />
                    </el-form-item>
                    <el-form-item label="FBBM Name">
                        <el-input v-model="fbbmDataDetail.maskingName" />
                    </el-form-item>
                </el-form>
                <div style="text-align:right;">
                    <el-button :loading="btnLoadingEditFbbm" type="primary" size="medium" class="animated fadeInRight" @click="editFbbm('fbbm')">
                        Save
                    </el-button>
                    <el-button type="danger" size="medium" class="animated fadeInRight" @click="dialogEditFbbm=false">
                        Cancel
                    </el-button>
                </div>
            </el-card>
        </el-row>
    </el-dialog>

    <!-- modal dialog add client -->
    <el-dialog title="Add Client" :visible.sync="dialogAddClient" v-loading="loadingAddClient" id="html-2-pdfwrapper">
        <el-row>
            <el-card class="mb-5">
                <el-form label-width="120px">
                    <el-form-item label="Client Name">
                        <el-input v-model="addClient.client_name" placeholder="Client Name" style="width:300px;"/>
                    </el-form-item>
                    <el-form-item label="Initial">
                        <el-input v-model="addClient.initial" placeholder="Initial" style="width:300px;"/>
                    </el-form-item>
                    <el-form-item label="NPWP Number">
                        <el-input v-model="addClient.npwp_number" @keypress.native="numberOnly" placeholder="NPWP Number" style="width:300px;"/>
                    </el-form-item>
                    <el-form-item label="NPWP Address">
                        <el-input v-model="addClient.npwp_address" placeholder="NPWP Address" style="width:300px;"/>
                    </el-form-item>
                    <el-form-item label="TAX Type">
                        <el-select v-model="addClient.tax_type" placeholder="Status" :default-first-option="true" class="mb-10 mr-5" style="width:300px;">
                            <el-option
                                v-for="item in taxType"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Document">
                        <el-upload
                            class="upload-demo"
                            id="inputMedia"
                            :http-request="renderMedia"
                            :before-upload="beforeUploadMedia"
                            action=""
                            :limit="1"
                            drag
                            list-type="text"
                        >
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text" @click="renderMedia">
                                    Drop file here or <em>click to upload</em>
                                </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="Status">
                        <el-select v-model="addClient.status" placeholder="Status" :default-first-option="true" class="mb-10 mr-5" style="width:300px;" @change="statusChange">
                            <el-option
                                v-for="item in optionStatus"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Churn Date" v-if="addClient.status === 'churn'">
                        <el-date-picker
                            v-model="addClient.churn_date"
                            type="date"
                            placeholder="Pick a day"
                            size="medium"
                            style="width:300px;"
                        />
                    </el-form-item>
                </el-form>
                <div style="text-align:right;">
                    <el-button :loading="btnAddClient" @click="createClient()" type="primary" size="medium" class="animated fadeInRight">
                        Add
                    </el-button>
                    <el-button type="danger" size="medium" class="animated fadeInRight" @click="dialogAddClient=false">
                        Cancel
                    </el-button>
                </div>
            </el-card>
        </el-row>
    </el-dialog>

    <!-- modal dialog edit client -->
    <el-dialog title="Edit Client" :visible.sync="dialogEditClient" v-loading="loadingEditClient" id="html-2-pdfwrapper">
        <el-row>
            <el-card class="mb-5">
                <el-form label-width="120px">
                    <el-form-item label="Client Name">
                        <el-input v-model="clientDetail.name" placeholder="Client Name" style="width:300px;"/>
                    </el-form-item>
                    <el-form-item label="Initial">
                        <el-input v-model="clientDetail.initial" placeholder="Initial" style="width:300px;"/>
                    </el-form-item>
                    <el-form-item label="NPWP Number">
                        <el-input @keypress.native="numberOnly" v-model="clientDetail.npwp_number" placeholder="NPWP Number" style="width:300px;"/>
                    </el-form-item>
                    <el-form-item label="NPWP Address">
                        <el-input v-model="clientDetail.npwp_address" placeholder="NPWP Number" style="width:300px;"/>
                    </el-form-item>
                    <el-form-item label="TAX Type">
                        <el-select v-model="addClient.tax_type" placeholder="Status" :default-first-option="true" class="mb-10 mr-5" style="width:300px;">
                            <el-option
                                v-for="item in taxType"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Document">
                        <el-upload
                            class="upload-demo"
                            id="inputMedia"
                            :http-request="renderMedia"
                            :before-upload="beforeUploadMedia"
                            drag
                            :limit="1"
                            action=""
                            list-type="text"
                        >
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text" @click="renderMedia">
                                    Drop file here or <em>click to upload</em>
                                </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="Status">
                        <el-select v-model="clientDetail.status" placeholder="Status" style="width:300px;" :default-first-option="true" class="mb-10 mr-5">
                            <el-option
                                v-for="item in optionStatus"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Churn Date" v-if="clientDetail.status === 'churn'">
                        <el-date-picker
                            v-model="clientDetail.churn_date"
                            type="date"
                            placeholder="Pick a day"
                            size="medium"
                            style="width:300px;"
                        />
                    </el-form-item>
                </el-form>
                <div style="text-align:right;">
                    <el-button @click="editClient()" type="primary" size="medium" class="animated fadeInRight" :loading="btnLoadingEditClient">
                        Save
                    </el-button>
                    <el-button type="danger" size="medium" class="animated fadeInRight" @click="dialogEditClient=false">
                        Cancel
                    </el-button>
                </div>
            </el-card>
        </el-row>
    </el-dialog>

    <!-- modal dialog add assign number -->
    <el-dialog title="Add Assign Number" :visible.sync="dialogAddAssignNumber" v-loading="loadingAddAssignNumber" id="html-2-pdfwrapper">
        <el-row>
            <el-card class="mb-5">
                <el-form label-width="120px">
                    <el-form-item label="Client Name">
                        <el-select placeholder="Client Name" v-model="addAssign.client_name" style="width:300px;" :default-first-option="true" remote-show-suffix filterable>
                            <el-option
                                v-for="item in clientData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Company Name">
                        <el-select placeholder="Company Name" @change="companySelected" v-model="addAssign.company_name" style="width:300px;" :default-first-option="true" remote-show-suffix filterable>
                            <el-option
                                v-for="(item, idx) in consumenData"
                                :label="item.customer_name"
                                :value="item.customer_id"
                                :key="idx"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Phone Number" v-if="addAssign.company_name">
                        <el-select v-model="addAssign.phone_number" style="width:300px;" :default-first-option="true" placeholder="Phone Number">
                            <el-option
                                v-for="(item, idx) in listPhoneNumber"
                                :label="item"
                                :value="item"
                                :key="idx"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Phone Owner">
                        <el-input v-model="addAssign.phone_owner" style="width:300px;" placeholder="Phone Owner" />
                    </el-form-item>
                    <el-form-item label="WABA ID">
                        <el-select v-model="addAssign.waba_id" filterable placeholder="Select WABA ID" style="width:300px">
                            <el-option
                                v-for="(item, key) in fbIdentityWaba"
                                :key="key"
                                :label="item.maskingName || '-'"
                                :value="item.identityNumber"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="FBBM ID">
                        <el-select v-model="addAssign.fbbm_id" filterable placeholder="Select FBBM ID" style="width:300px" clearable>
                            <el-option
                                v-for="(item, key) in fbIdentityFbbm"
                                :key="key"
                                :label="item.maskingName || '-'"
                                :value="item.identityNumber"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="PIC Name">
                        <el-select v-model="addAssign.pic_name" placeholder="PIC Name" style="width:300px;" :default-first-option="true">
                            <el-option
                                v-for="item in listPic"
                                :label="item.label"
                                :key="item.user_id"
                                :value="item.user_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Status">
                        <el-select v-model="addAssign.status" placeholder="Status" style="width:300px;" :default-first-option="true" @change="statusChange">
                            <el-option
                                v-for="item in optionStatus"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Churn Date" v-if="addAssign.status === 'churn'">
                        <el-date-picker
                            v-model="addAssign.churn_date"
                            type="date"
                            placeholder="Pick a day"
                            size="medium"
                            style="width: 300px"
                        />
                    </el-form-item>
                </el-form>
                <div style="text-align:right;">
                    <el-button :loading="btnLoadingCreateAssign" @click="createAssign()" type="primary" size="medium" class="animated fadeInRight">
                        Add
                    </el-button>
                    <el-button type="danger" size="medium" class="animated fadeInRight" @click="dialogAddAssignNumber=false">
                        Cancel
                    </el-button>
                </div>
            </el-card>
        </el-row>
    </el-dialog>

    <!-- modal dialog edit assign number -->
    <el-dialog title="Edit Assign Number" :visible.sync="dialogEditAssignNumber" v-loading="loadingEditAssignNumber" id="html-2-pdfwrapper">
        <el-row>
            <el-card class="mb-5">
                <el-form label-width="120px">
                    <el-form-item label="Client Name">
                        <el-select v-model="assignDetail.client_name" style="width:300px;" :default-first-option="true">
                            <el-option
                                v-for="item in clientData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Company Name">
                        <el-select v-model="assignDetail.customer_name" style="width:300px;" :default-first-option="true" @change="selectCompanyEdit">
                            <el-option
                                v-for="(item, idx) in consumenData"
                                :label="item.customer_name"
                                :value="item.customer_id"
                                :key="idx"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Phone Number">
                        <el-select v-model="assignDetail.phone_number" style="width:300px;" :default-first-option="true">
                            <el-option
                                v-for="(item, idx) in listPhoneNumber"
                                :label="item"
                                :value="item"
                                :key="idx"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Phone Owner">
                        <el-input v-model="assignDetail.phone_owner" style="width:300px;"/>
                    </el-form-item>
                    <el-form-item label="WABA ID">
                        <el-select v-model="assignDetail.waba_id" filterable placeholder="Select WABA ID" style="width:300px">
                            <el-option
                                v-for="(item, key) in fbIdentityWaba"
                                :key="key"
                                :label="item.maskingName || '-'"
                                :value="item.identityNumber"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="FBBM ID">
                        <el-select v-model="assignDetail.fbbm_id" filterable placeholder="Select FBBM ID" style="width:300px" clearable>
                            <el-option
                                v-for="(item, key) in fbIdentityFbbm"
                                :key="key"
                                :label="item.maskingName || '-'"
                                :value="item.identityNumber"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="PIC Name">
                        <el-select v-model="assignDetail.pic_name" placeholder="PIC Name" style="width:300px;" :default-first-option="true">
                            <el-option
                                v-for="item in listPic"
                                :label="item.label"
                                :key="item.user_id"
                                :value="item.user_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Status">
                        <el-select v-model="assignDetail.status" placeholder="Status" style="width:300px;" :default-first-option="true">
                            <el-option
                                v-for="item in optionStatus"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Churn Date" v-if="assignDetail.status === 'churn'">
                        <el-date-picker
                            v-model="assignDetail.churn_date"
                            type="date"
                            placeholder="Pick a day"
                            size="medium"
                            style="width:300px;"
                        />
                    </el-form-item>
                </el-form>
                <div style="text-align:right;">
                    <el-button @click="editAssign()" type="primary" size="medium" class="animated fadeInRight">
                        Save
                    </el-button>
                    <el-button type="danger" size="medium" class="animated fadeInRight" @click="dialogEditAssignNumber=false">
                        Cancel
                    </el-button>
                </div>
            </el-card>
        </el-row>
    </el-dialog>

	<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
		DAM Corp.
	</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
import axios from 'axios'
const _ = require('lodash')
const moment = require('moment')

export default {
    name: 'bussiness_data',
	components: {
	},
	data () {
		return {
            activeTab: 'wabaIdentity',
            loadingTable: false,
            dialogAddWabaIdentity: false,
            dialogAddFbbm: false,
            dialogAddClient: false,
            dialogAddAssignNumber: false,
            dialogEditAssignNumber: false,
            dialogEditClient: false,
            dialogEditFbbm: false,
            dialogEditWabaIdentity: false,
            loadingFbbm: false,
            loadingFbbmDetail: false,
            loadingBtnEditFbbm: false,
            loadingBtnDeleteWaba: false,
            loadingBtnDeleteFbbm: false,
            loadingEditAssignNumber: false,
            loadingAddAssignNumber: false,
            loadingBtn: false,
            loadingEditClient: false,
            loadingAddClient: false,
            loadingAddFbbm: false,
            loadingEditWabaIdentity: false,
            loadingAddWabaIdentity: false,
            loadingReportTable: false,
            btnLoadingEditFbbm: false,
            btnLoadingEditWaba: false,
            btnAddClient: false,
            periodLimitSelect: [
                {
                    label: 'All',
                    value: ''
                },
                {
                    label: 'To expire in 3 months',
                    value: 3
                },
                {
                    label: 'To expire in 2 months',
                    value: 2
                },
                {
                    label: 'To expire in 1 month',
                    value: 1
                }
            ],
            statusAddClient: [
                {
                    name: 'On Board',
                    value: 'on_board'
                },
                {
                    name: 'Churn',
                    value: 'churn'
                }
            ],
            fbbmData: [],
            wabaData: [],
            fbbmDataDetail: {},
            wabaDataDetail: {},
            addFbbm: {
                fbbmId: '',
                fbbmName: '',
                fbbmType: 'fbbm'
            },
            addWaba: {
                wabaId: '',
                wabaName: '',
                wabaType: 'waba',
                pic: ''
            },
            optionStatus: [
                {
                    name: 'Onboard',
                    value: 'onboard'
                },
                {
                    name: 'Churn',
                    value: 'churn'
                }
            ],
            clientDetail: {},
            addClient: {
                client_name: '',
                initial: '',
                npwp_number: '',
                npwp_address: '',
                status: '',
                churn_date: '',
                files: '',
                tax_type: ''
            },
            searchFbbm: '',
            searchWaba: '',
            clientData: [],
            assignData: [],
            assignDetail: {},
            addAssign: {
                client_name: '',
                company_name: '',
                phone_number: '',
                phone_owner: '',
                waba_id: '',
                fbbm_id: '',
                pic_name: '',
                status: '',
                churn_date: ''
            },
            filterSearchAssign: {
                client_id: '',
                customer_id: ''
            },
            paginationWaba: {
                page: 1,
                total: 0
            },
            paginationFbbm: {
                page: 1,
                total: 0
            },
            paginationClient: {
                page: 1,
                total: 0
            },
            paginationAssign: {
                page: 1,
                total: 0
            },
            consumenData: [],
            listPhoneNumber: [],
            filterSearchClientName: '',
            listCustomer: [],
            listPic: [],
            listClient: [],
            listCustomerClient: [],
            btnLoadingCreateAssign: false,
            btnLoadingAddWaba: false,
            fbbmListData: [],
            wabaListData: [],
            loadingTableWabaIdentity: false,
            fbIdentityWaba: [],
            fbIdentityFbbm: [],
            taxType: [
                {
                    value: 'none',
                    name: 'None'
                },
                {
                    value: 'pp',
                    name: 'PP23'
                },
                {
                    value: 'pph',
                    name: 'PPH23'
                }
            ],
            wabaTotalData: 0,
            fbbmTotalData: 0,
            clientTotalData: 0,
            assignTotalData: 0,
            btnLoadingEditClient: false,
            loadingPage: false,
            optionWabaSelectBy: [
                {
                    name: 'WABA ID',
                    value: 'waba_id'
                },
                {
                    name: 'WABA Name',
                    value: 'masking_name'
                }
            ],
            optionAssignSelectBy: [
                {
                    name: 'WABA ID',
                    value: 'waba_id'
                },
                {
                    name: 'Client Name',
                    value: 'client_name'
                }
            ],
            wabaSelectBy: '',
            wabaPlaceholder: '',
            searchAssignWabaId: ''
		}
	},
	methods: {
        log(data){
            console.log(data, " <<data");
        },
        selectClientFilter() {
            this.filterSearchAssign.customer_id='';
            this.listCustomerClient = [];
            this.listClient.map(item => {
                if (item.id === this.filterSearchAssign.client_id) {
                    this.listCustomerClient = item.master_client_assigns;
                }
            })
        },
        selectWabaSearch() {
            if (this.wabaSelectBy === 'waba_id') {
                this.wabaPlaceholder = 'Search by Waba Id'
            } else if (this.wabaSelectBy === 'masking_name') {
                this.wabaPlaceholder = 'Search by Waba Name'
            }
        },
        statusChange() {
            if (this.addClient.status === 'onboard') {
                this.addClient.churn_date = '';
                this.addAssign.churn_date = '';
            }
        },
        companySelected() {
            this.addAssign.phone_number = ''
            var id = this.addAssign && this.addAssign.company_name ? this.addAssign.company_name : '';
            this.loadWA(id);
        },
        selectCompanyEdit() {
            this.assignDetail.phone_number = ''
            var id = this.assignDetail && this.assignDetail.customer_name ? this.assignDetail.customer_name : '';
            this.loadWA(id);
        },
        async loadWA(id) {
			await api({
				method: 'post',
				url: config.baseApi +'user/'+id+'/detail_number'
			}).then(result => {
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                const data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : [];
				if(status == 200){
                    this.listPhoneNumber = data;
				} else {
                    this.listPhoneNumber = [];
                }
			}).catch(error => {
                console.log('Error:', error)
			})
		},
        numberOnly(e) {
			// console.log(e);
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,46,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        beforeUploadMedia(object){
            if(["application/pdf"].indexOf(object.type)==-1){
				this.$swal(this.$t('error'), "Media extension not match (.pdf)", "warning")
				return false
			}
		},
        async renderMedia(object){
            this.addClient.files = [];
            this.clientDetail.doc = [];

            if(object.file.size >= 104857600){
                this.closeDialog()
                this.$swal(this.$t('error'), "Maximum file upload size is 100 MB", "warning")
                return
            }

            this.addClient.files = object.file;
            this.clientDetail.doc = object.file;
        },
        async uploadMedia(type) {
            let formData = new FormData();
            let date = new Date();
            formData.append('files', this.addClient.files);
            formData.append('name', this.addClient.client_name);
            formData.append('initial', this.addClient.initial);
            formData.append('npwp_number', this.addClient.npwp_number);
            formData.append('npwp_address', this.addClient.npwp_address);
            formData.append('status', this.addClient.status);
            formData.append('churn_date', this.addClient.status === 'churn' ? moment(this.addClient.churn_date).format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD'));
            formData.append('source', type);
            formData.append('tax_type', this.addClient.tax_type);

            let apiOptions = {
                timeout: 60000 * 5,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }

            if (!this.validation(type)) {
                if(type === 'client') {
                    this.btnAddClient = true;
                }
    
                await axios.post(config.baseApi + 'master-client', formData, apiOptions).then(resp => {
                    let status =
                        resp &&
                        resp.data &&
                        resp.data.ec
                            ? resp.data.ec
                            : null;
                    let message =
                        resp &&
                        resp.data &&
                        resp.data.message
                            ? resp.data.message
                            : 'Failed to send data!';
                    if (status === 200) {
                        if(type === 'client') {
                            this.dialogAddClient = false;
                            this.btnAddClient = false;
                            this.getClient();
                        }
                        this.$swal(this.$t('success'), this.$t('success'), "success");
                    } else if (status === 500) {
                        this.btnAddClient = false;
                        this.$swal(this.$t('error'), message, "error");
                    } else {
                        this.btnAddClient = false;
                        this.$swal(this.$t('error'), 'Failed to send data!', "error");
                    }
                    this.paginationClient.page=1;
                }).catch(err => {
                    this.btnAddClient = false;
                    console.error(err);
                })
            }
        },
        searchFbbmWaba(type) {
            var search;
            if (type == 'waba') {
                search = this.searchWaba;
            } else if (type == 'fbbm') {
                search = this.searchFbbm
            }
            this.getFbbmWaba(type, search);
        },
        filterAssign(){
            this.getAssign();
        },
        paginationWabaChange(page) {
            this.paginationWaba.page = page;
            this.getFbIdentity('waba', null, this.paginationWaba.page, 20);
        },
        paginationFbbmChange(page) {
            this.paginationFbbm.page = page;
            this.getFbIdentity('fbbm', null, this.paginationFbbm.page, 20);
        },
        paginationClientChange(page) {
            this.paginationClient.page = page;
            this.getClient(this.paginationClient.page);
        },
        paginationAssignChange(page) {
            this.paginationAssign.page = page;
            this.getAssign(this.paginationAssign.page);
        },
        btnSearchWaba() {
            this.getFbIdentity('waba', this.wabaSelectBy);
        },
        async getFbIdentity(type = '', filter = '', page = 1, limit = 20){
            this.loadingTableWabaIdentity=true;
            this.loadingPage=true;
			let params = {
                page: page,
                limit: limit,
                filter: filter,
                search: type === 'waba' ? this.searchWaba : this.searchFbbm
            }

            if (type === 'waba') {
                params.type = 'waba_id'
            } else {
                params.type = 'fbbm_id'
            }

			await api({
				url: config.baseApi+'bussiness/get-fb-identity',
				method: 'GET',
				params: params
			}).then(res => {
                let data =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.consumen
                        ? res.data.data.consumen
                        : [];
                let total =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.total
                        ? res.data.data.total
                        : 0;

                if (type === 'waba') {
                    this.wabaListData = data;
                    this.wabaTotalData = total;
                } else if (type === 'fbbm') {
                    this.fbbmListData = data;
                    this.fbbmTotalData = total;
                }

                this.loadingTableWabaIdentity=false;
			}).catch(error => {
				console.log("err", error);
                this.loadingTableWabaIdentity=false;
			})
            this.loadingPage=false;
		},
        async getFbbmWaba(type = '', search = '', page = 1, limit = 20){
            this.loadingFbbm = true;

            var params = {
                page: page,
                limit: limit,
                type: type,
                q: search
            }

            if (type === 'waba') {
                params.q = this.searchWaba;
            } else if (type === 'fbbm') {
                params.q = this.searchFbbm;
            }

            await api({
                method: 'get',
                url:config.baseApi+'master-waba-fbbm',
                params
            }).then(result => {
                const data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                const total =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.count
                        ? result.data.data.count
                        : 0;
                
                if (status === 200) {
                    if (type === 'fbbm') {
                        this.fbbmData = data;
                        this.paginationFbbm.total = total;
                    } else if (type === 'waba') {
                        this.wabaData = data;
                        this.paginationWaba.total = total;
                    }
                }
                this.loadingFbbm = false;
            }).catch(error => {
                console.error("Failed : " + error);
                this.loadingFbbm = false;
            })
	    },
        async getDetailFbbm(id, type = ''){
            let data = type === 'waba' ? this.wabaListData : this.fbbmListData;
            let tempData = {};

            data.map(item => {
                if (item.id === id) tempData = item;
            })

            if (type === 'fbbm') {
                this.dialogEditFbbm = true;
                this.fbbmDataDetail = tempData;
            } else if (type === 'waba') {
                this.dialogEditWabaIdentity = true;
                this.wabaDataDetail = tempData;
            }
	    },
        async deleteFbbm(id, type = '', name){
            await this.$swal({
                title: `Are you sure want to delete this ${type === 'fbbm' ? 'FBBM' : 'WABA'} ${name}?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (type === 'fbbm') {
                    this.loadingBtnDeleteFbbm = true;
                } else if (type === 'waba') {
                    this.loadingBtnDeleteWaba = true;
                }
                
                api({
                    method: 'delete',
                    url: config.baseApi+`bussiness/remove-fb-identity/${id}`,
                }).then(result => {
                    const status =
                        result &&
                        result.data &&
                        result.data.ec
                            ? result.data.ec
                            : null;

                    if(status === 200) {
                        this.loadingBtnDeleteFbbm = false;
                        this.loadingBtnDeleteWaba = false;
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                        this.getFbIdentity('waba');
                        this.getFbIdentity('fbbm');
                    } else {
                        this.$swal(this.$t('error'), 'Failed to delete data!', "error")
                    }
                }).catch(error => {
                    this.loadingBtnDeleteFbbm = false;
                    this.loadingBtnDeleteWaba = false;
                    console.error("Failed : " + error);
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                })
            }).catch(err => {
                console.log(err);
            })
        },
        async editFbbm(type = ''){
            let data = {
                id: 
                    this.fbbmDataDetail &&
                    this.fbbmDataDetail.id
                        ? this.fbbmDataDetail.id
                        : '',
                identityNumber:
                    this.fbbmDataDetail &&
                    this.fbbmDataDetail.identityNumber
                        ? this.fbbmDataDetail.identityNumber
                        : '',
                maskingName:
                    this.fbbmDataDetail &&
                    this.fbbmDataDetail.maskingName
                        ? this.fbbmDataDetail.maskingName
                        : '',
                type:
                    this.fbbmDataDetail &&
                    this.fbbmDataDetail.type
                        ? this.fbbmDataDetail.type
                        : ''
            }

            if (type === 'waba') {
                data = {
                    id:
                        this.wabaDataDetail &&
                        this.wabaDataDetail.id
                            ? this.wabaDataDetail.id
                            : '',
                    identityNumber: 
                        this.wabaDataDetail &&
                        this.wabaDataDetail.identityNumber
                            ? this.wabaDataDetail.identityNumber
                            : '',
                    maskingName: 
                        this.wabaDataDetail &&
                        this.wabaDataDetail.maskingName
                            ? this.wabaDataDetail.maskingName
                            : '',
                    pic_business: 
                        this.wabaDataDetail &&
                        this.wabaDataDetail.pic_business
                            ? this.wabaDataDetail.pic_business
                            : '',
                    type: 
                        this.wabaDataDetail &&
                        this.wabaDataDetail.type
                            ? this.wabaDataDetail.type
                            : '',
                }
            }

            let id;
            if (type === 'waba') {
                id =
                    this.wabaDataDetail &&
                    this.wabaDataDetail.id
                        ? this.wabaDataDetail.id
                        : '';
                this.btnLoadingEditWaba = true;
            } else if ( type === 'fbbm') {
                id =
                    this.fbbmDataDetail &&
                    this.fbbmDataDetail.id
                        ? this.fbbmDataDetail.id
                        : '';
                this.btnLoadingEditFbbm = true;
            }

            let apiOptions = {
                url: config.baseApi+'bussiness/update-fb-identity',
				method: 'POST',
				data: data
            }

            await api(apiOptions)
            .then(result => {
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                if (status === 200) {
                    this.btnLoadingEditFbbm = false;
                    this.btnLoadingEditWaba = false;
                    this.dialogEditWabaIdentity = false;
                    this.dialogEditFbbm = false;
                    this.$swal(this.$t('success'), this.$t('success'), "success");
                    this.getFbIdentity('fbbm', null, this.paginationFbbm.page);
                    this.getFbIdentity('waba', null, this.paginationWaba.page);
                } else {
                    this.$swal(this.$t('error'), 'Failed to edit data!', "error");
                }
            }).catch(error => {
                console.error("Failed : " + error);
                this.btnLoadingEditFbbm = false;
                this.btnLoadingEditWaba = false;
            })
	    },
        async createFbbmWaba(type = ''){
            var data = {
                identityNumber: this.addFbbm.fbbmId,
                maskingName: this.addFbbm.fbbmName,
                type: 'fbbm_id'
            }

            if (type === 'waba') {
                data = {
                    identityNumber: this.addWaba.wabaId,
                    maskingName: this.addWaba.wabaName,
                    type: 'waba_id',
                    pic_business: this.addWaba.pic
                }
            }

            if (!this.validation(type)) {
                this.btnLoadingAddWaba=true;
                await api({
                    url:config.baseApi+'bussiness/add-fb-identity',
                    method:'POST',
                    data:data
                }).then(result => {
                    let status =
                        result &&
                        result.data &&
                        result.data.ec
                            ? result.data.ec
                            : null;
                    if(status === 200){
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                        this.dialogAddWabaIdentity = false;
                        this.dialogAddFbbm = false;
                        this.getFbIdentity('waba');
                        this.getFbIdentity('fbbm');
                    } else {
                        this.$swal(this.$t('error'), 'Failed to save Waba Identity!', "error")
                    }
                    this.btnLoadingAddWaba=false;
                }).catch(error => {
                    console.error("Failed : " + error);
                    this.btnLoadingAddWaba=false;
                })
            }
        },
        async getClient(page = 1){
            var params = {
                page: page,
                limit: 20,
                q: this.filterSearchClientName
            }

            await api({
                method: 'get',
                url:config.baseApi+'master-client',
                params
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                var total =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.total
                        ? result.data.data.total
                        : 0;
                if(status === 200) {
                    this.clientData = data;
                    this.clientTotalData = total;
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
	    },
        async createClient(){
            this.uploadMedia('client')
        },
        async deleteClient(id, type = '', name){
            await this.$swal({
                title: `Are you sure want to delete this ${type === 'client' ? 'Client' : 'Assign'} ${name}?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
               
                api({
                    method: 'delete',
                    url: config.baseApi+`master-client/${id}`,
                }).then(result => {
                    const status =
                        result &&
                        result.data &&
                        result.data.ec
                            ? result.data.ec
                            : null;

                    if(status === 200) {
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                        this.getClient();
                    }
                }).catch(error => {
                    console.error("Failed : " + error);
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                })
            }).catch(err => {
                console.log(err);
            })
        },
        async getDetailClient(id, type = ''){
            this.loadingFbbmDetail = true;
            await api({
                method: 'get',
                url:config.baseApi+`master-client/${id}`,
            }).then(result => {
                const data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : {};
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;

                if (status === 200) {
                    this.dialogEditClient = true;
                    this.clientDetail = data;
                }
                this.loadingFbbmDetail = false;
            }).catch(error => {
                console.error("Failed : " + error);
                this.loadingFbbmDetail = false;
            })
	    },
        async editClient(type = ''){
            this.btnLoadingEditClient=true;
            var id = this.clientDetail.id
            let date = new Date();
            let formData = new FormData();
            formData.append('files', this.clientDetail.doc);
            formData.append('name', this.clientDetail.name);
            formData.append('initial', this.clientDetail.initial);
            formData.append('npwp_number', this.clientDetail.npwp_number);
            formData.append('npwp_address', this.clientDetail.npwp_address);
            formData.append('status', this.clientDetail.status);
            formData.append('churn_date', this.clientDetail.status === 'churn' ? moment(this.clientDetail.churn_date).format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD'));
            formData.append('source', 'client');
            formData.append('tax_type', this.clientDetail.tax_type);

            let apiOptions = {
                timeout: 60000 * 5,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }

            await axios.patch(config.baseApi + `master-client/${id}`, formData, apiOptions).then(result => {
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                if (status === 200) {
                    this.$swal(this.$t('success'), this.$t('success'), "success");
                    this.dialogEditClient = false;
                    this.getClient();
                    this.btnLoadingEditClient=false;
                } else {
                    this.btnLoadingEditClient=false;
                    this.$swal(this.$t('error'), 'Failed to edit data client!', "error");
                }
                this.paginationClient.page=1;
            }).catch(err => {
                console.error("Failed : " + error);
            })
	    },
        async getAssign(page = 1){
            var params = {
                page: page,
                limit: 20,
                waba_id: this.searchAssignWabaId,
                client_id: this.filterSearchAssign.client_id,
                customer_id: this.filterSearchAssign.customer_id
            };

            await api({
                method: 'get',
                url:config.baseApi+'master-client-assign',
                params
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                var total =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.count
                        ? result.data.data.count
                        : 0;
                if(status === 200) {
                    this.assignData = data;
                    this.assignTotalData = total;
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
	    },
        async createAssign(){
            let date = new Date();
            var data = {
                customer_id: this.addAssign.company_name,
                client_id: this.addAssign.client_name,
                phone_number: this.addAssign.phone_number,
                phone_owner: this.addAssign.phone_owner,
                waba_id: this.addAssign.waba_id,
                fbbm_id: this.addAssign.fbbm_id,
                pic: this.addAssign.pic_name,
                status: this.addAssign.status,
                churn_date: this.addAssign.status === 'churn' ? moment(this.addAssign.churn_date).format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
            }

            if (!this.validation('assign')) {
                this.btnLoadingCreateAssign=true;
                await api({
                    method: 'post',
                    url:config.baseApi+'master-client-assign',
                    data: data
                }).then(result => {
                    const status =
                        result &&
                        result.data &&
                        result.data.ec
                            ? result.data.ec
                            : null;
                    if (status === 200) {
                        this.$swal(this.$t('success'), this.$t('success'), "success");
                        this.dialogAddAssignNumber = false;
                        this.getAssign();
                    } else {
                        this.$swal(this.$t('error'), 'Failed to save data!', "error");
                    }
                    this.btnLoadingCreateAssign=false;
                    this.paginationAssign.page=1;
                }).catch(error => {
                    console.error("Failed : " + error);
                })
            }
        },
        async deleteAssign(id, type = '', name){
            name =
                name &&
                name.customer &&
                name.customer.master_client &&
                name.customer.master_client.name
                    ? name.customer.master_client.name
                    : '-';
            await this.$swal({
                title: `Are you sure want to delete this ${type === 'client' ? 'Client' : 'Assign'} ${name}?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                api({
                    method: 'delete',
                    url: config.baseApi+`master-client-assign/${id}`,
                }).then(result => {
                    const status =
                        result &&
                        result.data &&
                        result.data.ec
                            ? result.data.ec
                            : null;

                    if(status === 200) {
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                        this.getAssign();
                    } else {
                        this.$swal(this.$t('error'), 'Failed to delete data!', "error")
                    }
                }).catch(error => {
                    console.error("Failed : " + error);
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                })
            }).catch(err => {
                console.log(err);
            })
        },
        async getDetailAssign(id, type = ''){
            this.loadingFbbmDetail = true;
            await api({
                method: 'get',
                url:config.baseApi+`master-client-assign/${id}`,
            }).then(result => {
                const data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : {};
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;

                var data_temp = {
                    client_name: data.customer.master_client.name,
                    customer_name: data.customer.customer_name,
                    phone_number: data.phone_number,
                    phone_owner: data.phone_owner,
                    churn_date: data.churn_date,
                    waba_id: data.waba_id,
                    fbbm_id: data.fbbm_id,
                    pic_name: data.pic_name,
                    status: data.status,
                    data: data
                }

                if (status === 200) {
                    this.assignDetail = data_temp;
                    this.dialogEditAssignNumber = true;
                }
                this.loadingFbbmDetail = false;
            }).catch(error => {
                console.error("Failed : " + error);
                this.loadingFbbmDetail = false;
            })
	    },
        async editAssign(type = ''){
            let date = new Date();
            var params = {
                customer_id: this.assignDetail.data.customer_id,
                client_id: this.assignDetail.data.customer.master_client_id,
                phone_number: this.assignDetail.phone_number,
                phone_owner: this.assignDetail.phone_owner,
                waba_id: this.assignDetail.waba_id,
                fbbm_id: this.assignDetail.fbbm_id,
                pic: this.assignDetail.pic_name,
                status: this.assignDetail.status,
                churn_date: this.assignDetail.status === 'churn' ? moment(this.assignDetail.churn_date).format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
            }
            var id = this.assignDetail.data.id

            await api({
                method: 'patch',
                url:config.baseApi+'master-client-assign/'+id,
                data: params
            }).then(result => {
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                if (status === 200) {
                    this.$swal(this.$t('success'), this.$t('success'), "success");
                    this.dialogEditAssignNumber = false;
                    this.getAssign();
                }
                this.paginationAssign.page=1;
            }).catch(error => {
                console.error("Failed : " + error);
                this.btnLoadingEditFbbm = false;
                this.btnLoadingEditWaba = false;
            })
	    },
        async getConsumen(){
			await api({
				method: "get",
				url: config.baseApi + "consumen",
				params: {
                    customer_type: 2,
					query_by: 'waba_number',
                    dropdown: true
				}
			}).then(resp => {
                const status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                const data =
                    resp &&
                    resp.data &&
                    resp.data.data &&
                    resp.data.data.consumen
                        ? resp.data.data.consumen
                        : [];
				if(status == 200){
                    this.consumenData = data;
				}
			}).catch(err => {
				console.log("failed", err)
			})
		},
        async loadConsumen() {
            await api({
                url: config.baseApi + "notification/consumen",
                method: 'get',
                params: {
                    customer_type: 2
                }
            })
            .then(res => {
                let data =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.consumen
                        ? res.data.data.consumen
                        : [];
                let status =
                    res &&
                    res.data &&
                    res.data.ec
                        ? res.data.ec
                        : null;

				if(status === 200){
					this.listCustomer = data;
				}
            })
            .catch(err => {
                console.error(err);
            })
        },
        async loadAdmin(){
			await api({
				url:config.baseApi+'admin_credential',
				method:'GET'
			}).then(response => {
                let data =
                    response &&
                    response.data &&
                    response.data.data &&
                    response.data.data.admin
                        ? response.data.data.admin
                        : [];
                let status =
                    response &&
                    response.data &&
                    response.data.ec
                        ? response.data.ec
                        : null;

                let temp = [];
                data = data.map(item => {
                    item.value = item.username
                    item.label = item.username.charAt(0).toUpperCase() + item.username.slice(1)

                    temp.push(item);
                })

                if (status === 200) {
                    this.listPic = temp;
                }
			}).catch(error => {
				console.error(error);
			})
		},
        async listClientName() {
            await api({
				url:config.baseApi+'master-client-all',
				method:'GET'
			}).then(response => {
                let data =
                    response &&
                    response.data &&
                    response.data.data &&
                    response.data.data.rows
                        ? response.data.data.rows
                        : [];
                let status =
                    response &&
                    response.data &&
                    response.data.ec
                        ? response.data.ec
                        : null;

                if (status === 200) {
                    this.listClient = data
                }
			}).catch(error => {
				console.error(error);
			})
        },
        async getWabaFbbmId(filter = '') {
            await api({
				url: config.baseApi+'bussiness/get-fb-identity',
				method: 'GET',
				params: {
					all: true,
					filter: filter,
                    limit: 2000
				}
			}).then(res => {
                let dataTemp =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.consumen
                        ? res.data.data.consumen
                        : [];

                let dataWaba = dataTemp.filter(item => item.type === 'waba_id');
                let dataFbbm = dataTemp.filter(item => item.type === 'fbbm_id');
				switch (filter) {
					case "waba_id":
						this.fbIdentityWaba = this.fbIdentityWaba.concat(dataWaba)
						break;
					case "fbbm_id":
						this.fbIdentityFbbm = this.fbIdentityFbbm.concat(dataFbbm)
						break;
				}
			}).catch(error => {
				console.log(error);
			})
        },
        validation(type) {
            let allFilled = false;
            if (type === 'waba') {
                if (
                    this.addWaba.wabaId === '' ||
                    this.addWaba.wabaName === '' ||
                    this.addWaba.pic === ''
                ) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please fill all inputs!'
                    });
                    allFilled = true;
                }
            } else if (type === 'fbbm') {
                if (
                    this.addFbbm.fbbmId === '' ||
                    this.addFbbm.fbbmName === ''
                ) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please fill all inputs!'
                    });
                    allFilled = true;
                }
            } else if (type === 'client') {
                if (
                    this.addClient.client_name === '' ||
                    this.addClient.initial === '' ||
                    this.addClient.npwp_number === '' ||
                    this.addClient.npwp_address === '' ||
                    this.addClient.status === '' ||
                    (this.addClient.churn_date === '' && this.addClient.status !== 'onboard') ||
                    this.addClient.files === ''
                ) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please fill all inputs!'
                    });
                    allFilled = true;
                }
            } else if (type === 'assign') {
                if (
                    this.addAssign.client_name === '' ||
                    this.addAssign.company_name === '' ||
                    this.addAssign.phone_number === '' ||
                    this.addAssign.phone_owner === '' ||
                    this.addAssign.waba_id === '' ||
                    this.addAssign.pic_name === '' ||
                    this.addAssign.status === '' ||
                    (this.addAssign.churn_date === '' && this.addAssign.status !== 'onboard')
                ) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please fill all inputs!'
                    });
                    allFilled = true;
                }

                this.assignData.map(item => {
                    if(item.phone_number === this.addAssign.phone_number) {
                        this.$message.error({
                            showClose: false,
                            message: 'Phone number already used!'
                        });
                        allFilled = true;
                    }
                })
            }

            return allFilled;
        },
        clear(type) {
            if (type === 'fbbm') {
                this.addFbbm = {
                    fbbmId: '',
                    fbbmName: ''
                }
            } else if (type === 'waba') {
                this.addWaba = {
                    wabaId: '',
                    wabaName: '',
                    pic: ''
                }
            } else if (type === 'client') {
                this.addClient = {
                    client_name: '',
                    initial: '',
                    npwp_number: '',
                    npwp_address: '',
                    status: '',
                    churn_date: '',
                    files: ''
                }
            } else if (type === 'assign') {
                this.addAssign = {
                    client_name: '',
                    company_name: '',
                    phone_number: '',
                    phone_owner: '',
                    waba_id: '',
                    fbbm_id: '',
                    pic_name: '',
                    status: '',
                    churn_date: ''
                }
            }
        }
	},
	async mounted(){
        // await this.getFbbmWaba('waba');
        // await this.getFbbmWaba('fbbm');
        await this.getFbIdentity('waba');
        await this.getFbIdentity('fbbm');
        await this.getClient();
        await this.getAssign();
        await this.getConsumen();
        await this.loadConsumen();
        await this.loadAdmin();
        await this.listClientName();
        await this.getWabaFbbmId('waba_id');
        await this.getWabaFbbmId('fbbm_id');
	},
    created(){
    }
}
</script>
<style>
.swal2-container {
	z-index: 10000 !important;
}
</style>
<style lang="scss">
@import '../../assets/scss/_variables';
.chart {
     width: 100%;
     height: 400px;
 }
.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			margin-bottom: 30px;

			.logo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media screen and (max-width: 768px) {
	.page-invoice {
		.invoice {
			.invoice-middle {
				.project {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;
				}
			}
			.invoice-bottom {
				table {
					th {
						padding: 5px;
					}

					td {
						padding: 5px;
					}
				}
			}
		}
	}
}

@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}

	.page-invoice {
		.toolbar {
			display: none;
		}

		.invoice {
			box-shadow: none;
			max-width: 100%;
			padding: 0;
		}
	}
}
</style>
<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
